/**
 * Авторизация на хотспот
 */
const wifiLogin = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/wifi/login",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Отправка смс
 */
const requestCode = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/wifi/requestCode",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Проверка отправленного кода
 * Авторизация, перенаправление в интернет
 */
const inputCode = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/wifi/inputCode",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

export { inputCode, requestCode, wifiLogin };
